module.exports = "../../static/images/index_about_bg.413543.png";